import { IImageLibraryDto } from "@kuika/kuika-cl-model";
import { ImageLibraryService } from "../../../../services/image-library-service";
import type { ToolHandlerGroup } from "../types";

function isSuccessfulResponse(res: any): boolean {
  return !!res && res.status >= 200 && res.status < 300;
}

function getResponseErrorMessage(res: any, fallback: string): string {
  const status = res?.status ?? res?.response?.status;
  const data = res?.data ?? res?.response?.data;

  if (typeof data === "string" && status) {
    return `${fallback}: ${status} ${data}`;
  }

  if (data?.message && status) {
    return `${fallback}: ${status} ${data.message}`;
  }

  if (status) {
    return `${fallback}: ${status}`;
  }

  return fallback;
}

export const imageTools: ToolHandlerGroup = {
  async: {
    ui_project_list_images: async () => {
      const res = await ImageLibraryService.GetAll();
      if (!isSuccessfulResponse(res)) {
        return { error: getResponseErrorMessage(res, "Failed to list images") };
      }

      const images = (res.data || []).map((item: any) => {
        const url = item.content?.startsWith("data:") ? "(base64)" : item.content;
        return {
          id: item.id,
          fileName: item.fileName,
          url
        };
      });

      return { count: images.length, images };
    },

    ui_project_upload_image: async (input) => {
      const { fileName, content } = input;
      if (!fileName) return { error: "fileName is required" };
      if (!content) return { error: "content is required (base64 data URI)" };

      const payload: IImageLibraryDto[] = [{ fileName, content } as IImageLibraryDto];
      const res = await ImageLibraryService.AddOrUpdateResource(payload);
      if (!isSuccessfulResponse(res)) {
        return { error: getResponseErrorMessage(res, "Failed to upload image") };
      }

      return {
        success: true,
        message: `Uploaded image "${fileName}" to the image library`
      };
    }
  }
};
